import GrainIcon from "@mui/icons-material/Grain";
import ScienceRoundedIcon from "@mui/icons-material/ScienceRounded";
import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Link from "@mui/material/Link";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { app } from "../config/firebase";
import { useAuth } from "../context/auth-context";
import {
    createUserExperiment,
    getExperimentDetails,
    saveExperiment,
    updateUserExperiment,
} from "../services/sandbox-api.service";

export default function ExperimentDetailView() {
    const [createUserError, setCreateUserError] = useState(false);
    const [createUserErrorMessage, setCreateUserErrorMessage] = useState("");
    const [folderName, setfolderName] = useState("");
    const [subfolderName, setsubfolderName] = useState("");
    const [updateView, setupdateView] = useState();
    const [usersFileName, setusersFileName] = useState("");
    const [iconFileName, seticonFileName] = useState("");
    const [uploadingFile, setuploadingFile] = useState(false);
    const [uploadIconFile, setuploadIconFile] = useState(false);
    const [savingData, setsavingData] = useState(false);
    const [expFileName, setexpFileName] = useState("");
    const [expName, setexpName] = useState("");
    const [expUrl, setexpUrl] = useState("");
    const [expLabel, setexpLabel] = useState("");
    const [activateExp, setactivateExp] = useState(false);
    const [newUserShowCard, setnewUserShowCard] = useState(true);
    const [newUserId, setnewUserId] = useState("");
    const [openingType, setOpeningType] = useState();
    const [openingTypeLabel, setOpeningTypeLabel] = useState(
        "Seleccione tipo de apertura"
    );
    const [open, setOpen] = useState(false);

    const [disableSubmit, setDisableSubmit] = useState(true);

    const { user } = useAuth();
    const pathParameters = useParams();
    const navigate = useNavigate();

    const experimentID = pathParameters.idExperiment;

    const [loading, setLoading] = useState(true);
    const [usersColumnsData, setUsersColumnsData] = useState([]);

    const Input = styled("input")({
        display: "none",
    });

    const handleSwitchChange = async (event, row, action) => {
        const idUser = parseInt(row[0]);
        const payload = {
            showCard: event.target.checked,
        };

        const response = await updateUserExperiment(
            user.accessToken,
            experimentID,
            idUser,
            payload
        );
    };

    const columns = [
        {
            name: "Athlete ID",
            options: {
                filter: true,
            },
        },
        {
            name: "Show card",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowData = tableMeta.rowData;
                    if (rowData[1]) {
                        return (
                            <Switch
                                defaultChecked
                                onChange={(e) =>
                                    handleSwitchChange(e, rowData, "SHOWCARD")
                                }
                            />
                        );
                    } else {
                        return (
                            <Switch
                                onChange={(e) =>
                                    handleSwitchChange(e, rowData, "SHOWCARD")
                                }
                            />
                        );
                    }
                },
            },
        },
    ];

    const options = {
        filter: true,
        selectableRows: "none",
        download: false,
        print: false,
        filterType: "dropdown",
        responsive: "simple",
        rowsPerPage: 10,
    };

    useEffect(() => {
        const actualDate = Date.now();
        setsubfolderName(actualDate);
    }, []);

    useEffect(() => {
        if (expName == null || expName.length < 6) {
            setDisableSubmit(true);
        } else if (expUrl == null || expUrl.length < 6) {
            setDisableSubmit(true);
        } else {
            setDisableSubmit(false);
        }
    }, [expName, expUrl]);

    useEffect(() => {
        (async function () {
            try {
                const response = await getExperimentDetails(
                    user.accessToken,
                    experimentID
                );
                let dataList = [];
                const expData = response.data;
                dataList = expData.users.map((e) => [e.id, e.status]);
                setexpName(expData.name);
                setactivateExp(expData.active);
                setexpLabel(expData.label);
                if (expData.linkType === "webview") {
                    setOpeningType("webview");
                    setOpeningTypeLabel("Web");
                } else {
                    setOpeningType("native");
                    setOpeningTypeLabel("Package");
                }
                setexpUrl(expData.link);
                setUsersColumnsData(dataList);
                setfolderName(expData.folder);
                setLoading(false);
            } catch (e) {
                console.error(e);
            }
        })();
    }, [updateView]);

    const handleBreadcrumbsClick = () => {
        navigate(`/experiments/list`);
    };

    const handleRadioChange = (event) => {
        if (event.target.name === "webview") {
            setOpeningType("webview");
            setOpeningTypeLabel("Web");
        } else {
            setOpeningType("native");
            setOpeningTypeLabel("Package");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setsavingData(true);
        const payload = {
            expId: experimentID,
            name: expName,
            label: expLabel,
            openingType: openingType,
            link: expUrl,
            iconFile:
                iconFileName && iconFileName.length > 0
                    ? `${subfolderName}/${iconFileName}`
                    : null,
            usersFile:
                expFileName && expFileName.length > 0
                    ? `${subfolderName}/${expFileName}`
                    : null,
            folder: folderName,
            active: activateExp,
        };
        const response = await saveExperiment(user.accessToken, payload);
        setsavingData(false);
        if (response.data.experimentId) {
            setLoading(true);
            setupdateView(Date.now());
        } else {
            console.log("ERROR ON SUBMIT DATA");
            console.log(response);
        }
    };

    const onUploadCsvFile = (e) => {
        const file = e.target.files[0];
        // Get a reference to the storage service, which is used to create references in your storage bucket
        const storage = getStorage(app);
        const fileName = `users.csv`;
        setexpFileName(fileName);
        // Create a storage reference from our storage service
        const storageRef = ref(
            storage,
            `public-sandbox-experiments/${folderName}/${subfolderName}/${fileName}`
        );
        // 'file' comes from the Blob or File API
        setuploadingFile(true);
        uploadBytes(storageRef, file)
            .then((snapshot) => {
                setuploadingFile(false);
                setusersFileName(file.name);
            })
            .catch((err) => {
                console.log("===ERROR UPLOAD===");
                console.log(err);
                setuploadingFile(false);
                setexpFileName("");
            });
    };

    const onUploadIconFile = (e) => {
        const file = e.target.files[0];
        // Get a reference to the storage service, which is used to create references in your storage bucket
        const storage = getStorage(app);
        const fileName = `${file.name}`;
        // Create a storage reference from our storage service
        const storageRef = ref(
            storage,
            `public-sandbox-experiments/${folderName}/${subfolderName}/${fileName}`
        );
        // 'file' comes from the Blob or File API
        setuploadIconFile(true);
        uploadBytes(storageRef, file)
            .then((snapshot) => {
                setuploadIconFile(false);
                seticonFileName(file.name);
            })
            .catch((err) => {
                console.log("===ERROR UPLOAD===");
                console.log(err);
                setuploadIconFile(false);
            });
    };

    const handleChange = (event) => {
        if (event.target.name === "activateExp") {
            setactivateExp(event.target.checked);
        }
        if (event.target.name === "expName") {
            setexpName(event.target.value);
        }
        if (event.target.name === "expLabel") {
            setexpLabel(event.target.value);
        }
        if (event.target.name === "expUrl") {
            setexpUrl(event.target.value);
        }
        if (event.target.name === "athleteId") {
            setnewUserId(event.target.value);
        }
        if (event.target.name === "newUserShowCard") {
            setnewUserShowCard(event.target.checked);
        }
    };

    const handleClickOpen = () => {
        setnewUserId("");
        setnewUserShowCard(true);
        setCreateUserError(false);
        setCreateUserErrorMessage("");
        setOpen(true);
    };

    const handleClose = () => {
        setnewUserId("");
        setnewUserShowCard(true);
        setCreateUserError(false);
        setCreateUserErrorMessage("");
        setOpen(false);
    };

    const handleAddUserClick = async () => {
        const idUser = newUserId;
        const payload = {
            showCard: newUserShowCard,
        };
        setsavingData(true);
        setDisableSubmit(true);
        await createUserExperiment(
            user.accessToken,
            experimentID,
            idUser,
            payload
        )
            .then(() => {
                setupdateView(Date.now());
                setsavingData(false);
                setDisableSubmit(false);
                handleClose();
            })
            .catch((e) => {
                console.log(e.response.status);
                if (e.response.status === 400) {
                    // logica de error
                    if (e.response.data.code && e.response.data.code === 'user-already-exists') {
                        setCreateUserErrorMessage(
                            "El usuario ya se encuentra registrado en el experimento."
                        );
                        setCreateUserError(true);
                    } else {
                        setCreateUserErrorMessage(
                            "Ha ocurrido un error al agregar al usuario."
                        );
                        setCreateUserError(true);
                    }
                } else {
                    setCreateUserErrorMessage(
                        "Ha ocurrido un error al agregar al usuario."
                    );
                    setCreateUserError(true);
                }
            });
        setsavingData(false);
        setDisableSubmit(false);
    };

    return (
        <div className="container">
            <div className="container-exp-details">
                {loading && (
                    <div className="loader-experiments-details">
                        <CircularProgress />
                    </div>
                )}
                {!loading && (
                    <>
                        <div className="experiment-details-title">
                            <Breadcrumbs aria-label="breadcrumb">
                                <Typography
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                    color="text.primary">
                                    <ScienceRoundedIcon
                                        sx={{ mr: 0.5 }}
                                        fontSize="inherit"
                                    />
                                    <Link
                                        underline="hover"
                                        color="inherit"
                                        onClick={handleBreadcrumbsClick}
                                        className="mouse-pointer bread-link-parent">
                                        Experimentos
                                    </Link>
                                </Typography>
                                <Typography
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                    color="text.primary">
                                    <GrainIcon
                                        sx={{ mr: 0.5 }}
                                        fontSize="inherit"
                                    />
                                    {experimentID}
                                </Typography>
                            </Breadcrumbs>
                        </div>
                        <div className="experiment-details-body-container">
                            <div className="experiment-details-container">
                                <div className="form-exp-container">
                                    <div className="form-exp-title">
                                        Configuración general
                                    </div>
                                </div>
                                <div className="form-exp-container-inputs">
                                    <div className="w-100p">
                                        <TextField
                                            className="w-100p"
                                            required
                                            id="outlined-required"
                                            label="Name"
                                            name="expName"
                                            onChange={handleChange}
                                            value={expName}
                                        />
                                    </div>
                                    <div className="form-exp-container-inputs__upload">
                                        <TextField
                                            disabled
                                            id="outlined-helperText"
                                            label="Icono"
                                            helperText="* Icono que se mostrará a la izquierda del Nombre"
                                            className="pr-10 w-80p"
                                            value={iconFileName}
                                        />
                                        <label htmlFor="contained-button-icon-file">
                                            <Input
                                                onChange={onUploadIconFile}
                                                accept="image/png,image/jpeg"
                                                id="contained-button-icon-file"
                                                multiple
                                                type="file"
                                            />
                                            <LoadingButton
                                                loading={uploadIconFile}
                                                variant="contained"
                                                className="text-center"
                                                component="span">
                                                Subir
                                            </LoadingButton>
                                        </label>
                                    </div>
                                    <div className="w-100p">
                                        <TextField
                                            className="w-100p"
                                            id="outlined-required"
                                            label="Label"
                                            name="expLabel"
                                            onChange={handleChange}
                                            value={expLabel}
                                        />
                                    </div>
                                    <div className="form-exp-container-inputs__upload">
                                        <TextField
                                            disabled
                                            id="outlined-helperText"
                                            label="Archivo de usuarios"
                                            helperText="* Archivo csv para la carga masiva de usuarios"
                                            className="pr-10 w-80p"
                                            value={usersFileName}
                                        />
                                        <label htmlFor="contained-button-file">
                                            <Input
                                                onChange={onUploadCsvFile}
                                                accept="text/csv"
                                                id="contained-button-file"
                                                type="file"
                                            />
                                            <LoadingButton
                                                loading={uploadingFile}
                                                variant="contained"
                                                className="text-center"
                                                component="span">
                                                Subir
                                            </LoadingButton>
                                        </label>
                                    </div>
                                    <div className="w-100p">
                                        <RadioGroup
                                            row
                                            onChange={handleRadioChange}
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group">
                                            <FormControlLabel
                                                value="webview"
                                                name="webview"
                                                control={
                                                    <Radio
                                                        checked={
                                                            openingType ===
                                                            "webview"
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                }
                                                label="URL (WebView)"
                                            />
                                            <FormControlLabel
                                                value="native"
                                                name="native"
                                                control={
                                                    <Radio
                                                        checked={
                                                            openingType ===
                                                            "native"
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                }
                                                label="Modulo Nativo"
                                            />
                                        </RadioGroup>
                                        <TextField
                                            disabled={
                                                openingType === null ||
                                                openingType === undefined
                                            }
                                            className="w-100p"
                                            id="outlined-required"
                                            label={openingTypeLabel}
                                            name="expUrl"
                                            onChange={handleChange}
                                            value={expUrl}
                                        />
                                    </div>

                                    <div className="w-100p">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="activateExp"
                                                        checked={activateExp}
                                                        onChange={handleChange}
                                                    />
                                                }
                                                label="Activo"
                                            />
                                            <div className="helper-text">
                                                * Se mostrará el experimento
                                                inmediatamente a los usuarios
                                                cargados
                                            </div>
                                        </FormGroup>
                                    </div>
                                </div>
                                <LoadingButton
                                    className="w-100p"
                                    loading={savingData}
                                    disabled={disableSubmit}
                                    onClick={handleSubmit}
                                    variant="contained">
                                    Modificar expermiento
                                </LoadingButton>
                            </div>
                            <div className="experiment-details-right-container">
                                <div className="detail-users-title-container">
                                    <div className="form-exp-title">
                                        Usuarios
                                    </div>
                                    <Button
                                        variant="outlined"
                                        onClick={handleClickOpen}>
                                        Agregar usuario
                                    </Button>
                                </div>
                                <div className="experiment-users-table-container">
                                    <MUIDataTable
                                        className="table-no-shadown"
                                        title={""}
                                        data={usersColumnsData}
                                        columns={columns}
                                        options={options}
                                    />
                                </div>
                            </div>
                        </div>
                        {/*Edit user*/}
                        <Dialog
                            sx={{
                                "& .MuiDialog-container": {
                                    justifyContent: "",
                                    alignItems: "flex-start",
                                },
                            }}
                            PaperProps={{
                                sx: {
                                    top: "10vh",
                                },
                            }}
                            fullWidth={false}
                            maxWidth="xs"
                            onClose={handleClose}
                            open={open}>
                            <DialogTitle>Agregar usuario</DialogTitle>
                            <DialogContent>
                                <div className="add-user-container">
                                    <div className="add-user-input-container">
                                        <TextField
                                            className="w-100p"
                                            required
                                            id="outlined-required"
                                            label="Athlete ID"
                                            name="athleteId"
                                            type="number"
                                            onChange={handleChange}
                                            value={newUserId}
                                        />
                                    </div>
                                    <div className="add-user-checkbox-container">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="newUserShowCard"
                                                    checked={newUserShowCard}
                                                    onChange={handleChange}
                                                />
                                            }
                                            label="Show card"
                                        />
                                    </div>
                                </div>
                                {createUserError && (
                                    <div className="add-user-error-message add-user-form-element">
                                        <Alert severity="warning">
                                            {createUserErrorMessage}
                                        </Alert>
                                    </div>
                                )}
                            </DialogContent>

                            <DialogActions>
                                <LoadingButton
                                    className="w-100p"
                                    loading={savingData}
                                    disabled={disableSubmit}
                                    onClick={handleAddUserClick}
                                    variant="contained">
                                    Agregar
                                </LoadingButton>
                            </DialogActions>
                        </Dialog>
                    </>
                )}
            </div>
        </div>
    );
}
